export default __webpack_public_path__ + "assets/icons/lijichaxun.5f19a934.svg";